import React from 'react';
import { TrophyIcon, CheckCircle2Icon } from 'lucide-react';
import { tomes, tomeIncludes } from '../data/content';
export function ProductSection() {
  return <section aria-labelledby="product" className="bg-ink px-5 py-20 sm:py-24" data-id="element-213" data-mp="2sj7x5vcl0it">
      <div className="mx-auto max-w-6xl" data-id="element-214" data-mp="hkl3idqdx7d1">
        <div className="text-center" data-id="element-215" data-mp="csthmgi6bpt8">
          <TrophyIcon className="mx-auto h-10 w-10 text-sun" aria-hidden="true" data-id="element-216" data-mp="crrzjs2qq320" />
          <h2 id="product" className="mt-4 text-3xl font-black uppercase leading-tight text-white sm:text-5xl" data-id="element-217" data-mp="qix1x1xht9g1">
            ReadyKit Digital™
            <span className="block text-brand" data-id="element-218" data-mp="mkfro9irziue">MegaPack Antipantallas Listo</span>
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-base font-black uppercase tracking-wide text-muted sm:text-lg" data-id="element-219" data-mp="10g1ov3z5x8xw">
            6 tomos + 5 bonos — Niños de 5 a 9 años — 315 páginas — Todo organizado.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-3xl border border-line bg-surface" data-id="element-220" data-mp="2xao0u5488qr4">
          <div className="hidden grid-cols-[180px_1fr_1.2fr] border-b border-line px-6 py-4 text-xs font-black uppercase tracking-widest text-muted md:grid" data-id="element-221" data-mp="3shh2lsh49h7b">
            <span data-id="element-222" data-mp="1bpawonoxwie">Tomo</span>
            <span data-id="element-223" data-mp="18tdd1fr99uh">Temática</span>
            <span data-id="element-224" data-mp="5c9cq5j7loav">Contenido principal</span>
          </div>
          <ul data-id="element-225" data-mp="5aohseszg3ch">
            {tomes.map(({
            n,
            title,
            content,
            icon: Icon,
            color
          }) => <li key={n} className="grid gap-3 border-b border-line px-6 py-5 last:border-b-0 md:grid-cols-[180px_1fr_1.2fr] md:items-center md:gap-6" data-id="element-226" data-mp="a4spx1dzihf5">
                <div className="flex items-center gap-3" data-id="element-227" data-mp="k0vxwnvipaa0">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl" style={{
                backgroundColor: color
              }} data-id="element-228" data-mp="k3i7su5vs1ve">
                    <Icon className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-229" data-mp="t2n4duxvtl4x" />
                  </span>
                  <span className="text-sm font-black uppercase tracking-wider" style={{
                color
              }} data-id="element-230" data-mp="2qswsnv9z9syp">
                    Tomo {n}
                  </span>
                </div>
                <h3 className="text-lg font-black text-white" data-id="element-231" data-mp="1z8f9udttz2i">{title}</h3>
                <p className="text-base text-muted" data-id="element-232" data-mp="21cfo2ciofy1">{content}</p>
              </li>)}
          </ul>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-[1.3fr_1fr] lg:gap-14" data-id="element-233" data-mp="azy2wasxoj55">
          <div data-id="element-234" data-mp="axtupgo04xz2">
            <h3 className="text-xl font-black uppercase tracking-wide text-white" data-id="element-235" data-mp="6ycmifh6xmq7">Cada tomo incluye:</h3>
            <ul className="mt-6 grid gap-x-8 gap-y-4 sm:grid-cols-2" data-id="element-236" data-mp="kxuet4tp3i4b">
              {tomeIncludes.map(item => <li key={item} className="flex gap-3 text-base font-semibold leading-relaxed text-cream" data-id="element-237" data-mp="fzswim43fmtw">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-238" data-mp="uo70j0d8xhc1" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-brand p-8 text-ink" data-id="element-239" data-mp="13nu2podsur65">
            <h3 className="text-sm font-black uppercase tracking-widest" data-id="element-240" data-mp="ypiqj70184kr">En total</h3>
            <p className="mt-3 text-7xl font-black leading-none" data-id="element-241" data-mp="ynft41wjv960">120</p>
            <p className="mt-1 text-lg font-black uppercase" data-id="element-242" data-mp="1ibu1bcqjxnxb">Actividades guiadas</p>
            <div className="mt-6 grid grid-cols-2 gap-4 border-t-2 border-ink/15 pt-6" data-id="element-243" data-mp="1n9cddbzv8j9j">
              <div data-id="element-244" data-mp="19bdz06ljomu1">
                <p className="text-4xl font-black leading-none" data-id="element-245" data-mp="199uluov6qrwh">+60</p>
                <p className="mt-1 text-sm font-black uppercase" data-id="element-246" data-mp="1dbg3eninzud0">Desafíos rápidos</p>
              </div>
              <div data-id="element-247" data-mp="zkjaswoqnd5y">
                <p className="text-4xl font-black leading-none" data-id="element-248" data-mp="zk19hln7y8r6">+60</p>
                <p className="mt-1 text-sm font-black uppercase" data-id="element-249" data-mp="14c1alhf0z7pc">Imprimibles</p>
              </div>
            </div>
            <p className="mt-6 text-sm font-bold leading-relaxed text-ink/80" data-id="element-250" data-mp="pnoemkfxtouu">
              180 propuestas entre actividades y desafíos, más 60 recursos imprimibles.
            </p>
          </div>
        </div>
      </div>
    </section>;
}